// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"06991b04","4":"70af2b35","8":"2dd81226","188":"46a9c346","224":"7112046e","421":"fb94f0f8","638":"d86658e9","787":"14675f11","864":"c96295e8","915":"54b87b49"}[chunkId] + ".chunk.js";
};